<!--
 * @Descripttion: 
 * @Author: 李子和
 * @Date: 2020-10-23 09:00:47
-->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  height: 100%
}

.el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue